import styled from "styled-components";

import {
  Form,
  Input as UnstyledInput,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import {
  getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const Content = styled.div`
  background-color: ${({
    theme: {
      colors: { mayAsWellBeWhite },
    },
  }) => mayAsWellBeWhite};
  padding: 0 38px 32px 38px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    padding: 15px 43px 32px 50px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding: 40px 50px 42px 50px;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    padding: 42px 50px 34px 50px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    display: grid;
    grid-column-gap: 76px;
    grid-template-columns: minmax(auto, 500px) minmax(auto, 525px);
    grid-template-rows: auto;
    justify-content: center;
    padding: 48px 50px 18px 50px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    grid-template-columns: minmax(auto, 753px) minmax(auto, 740px);
    padding: 78px 8.3% 64px 8.3%;
  }
`;

export const StyledForm = styled(Form)`
  display: grid;
  grid-row-gap: 10px;
  grid-template-columns: 295px;
  grid-auto-rows: auto;
  justify-content: center;
  margin-bottom: 1em;
  @media screen and (min-width: ${getSize("mobile480")}) {
    grid-template-columns: 387px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    grid-template-columns: 525px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    grid-template-columns: 740px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    grid-template-columns: 525px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    grid-template-columns: 740px;
  }
`;

export const Input = styled(UnstyledInput)`
  @media screen and (min-width: ${getSize(
      "tablet960"
    )}) and (max-width: 1199px) {
    font-size: 20px;
    padding: 14px 24px 13px 24px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    padding: 8px 17px 8px 17px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    font-size: 20px;
    padding: 14px 24px 13px 24px;
  }
`;

export const MergedGridRow = styled.div`
  display: contents;
  @media screen and (min-width: ${getSize("tablet720")}) {
    display: grid;
    grid-column-gap: 6px;
  }
`;

export const DealerBenefitsSection = styled.section`
  flex-direction: column;
  flex-basis: 42%;

  color: ${(p) => p.theme.colors.grey};

  @media screen and (max-width: ${getSize("large")}) {
    margin: 0;
  }
`;

export const DealerBenefitsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
export const DealerBenefitsItem = styled.li`
  list-style: none;
  margin: 24px 0px;
  padding: 0;
  @media screen and (min-width: ${getSize("tablet720")}) {
    margin: 31px 0px;
  }
`;

export const Title = styled.h2`
  color: ${(p) => p.theme.colors.blueGrey};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  @media screen and (min-width: ${getSize("tablet720")}) {
    font-size: 20px;
    letter-spacing: 0px;
    line-height: 31px;
  }
  ${getFontFamily("regular")}
`;

export const StyledP2 = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  @media screen and (min-width: ${getSize("tablet720")}) {
    font-size: 20px;
    letter-spacing: 0px;
    line-height: 31px;
  }
  ${getFontFamily("regular")}
`;
